import Header from "../../components/private/header";
import Navigation from "../../components/private/navigation";
import Main from "../../components/private/main";
import Founder from "../../components/private/founder";
import Footer from "../../components/private/footer";
import { getAuth } from "../../components/utils/auth";

export default () => {
  const user = getAuth();

  return (
    <>
      <Header user={user} />
      <Navigation />
      <Main content={<Founder user={user} />} />
      <Footer />
    </>
  );
};
